<div class="govuk-width-container">
  <gb-ui-header
      [imageDetail]="imageDetail"
      [showSearch]="false"
      [navLinks]="[]">
  </gb-ui-header>
</div>
